import { render } from "./ContactListItem.vue?vue&type=template&id=55adcb9e&scoped=true"
import script from "./ContactListItem.vue?vue&type=script&lang=ts"
export * from "./ContactListItem.vue?vue&type=script&lang=ts"

import "./ContactListItem.vue?vue&type=style&index=0&id=55adcb9e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55adcb9e"

export default script